module.exports = __webpack_public_path__ + "static/media/CircularXXWeb-Bold.6c9f99db.woff";